import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { SHOW_SNACKBAR } from "../utils/types";
import { generateTokenByApiKey } from "../api/login";
import { getEmailBody } from "../utils/helper";

const Contact = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);

    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }

  return (
    <>
      {/* breadcrumb start */}
      <div
        className="cta4-section-area mkt150 bg-[#243A5E]"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="cta-content-area heading1">
                <h2 className="text-anime-style-3">Contact Us</h2>
                <div className="space16" />
                <p>Your queries matter — contact us anytime.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* breadcrumb end */}

      {/*===== CONTACT AREA STARTS =======*/}
      <div className="contact-inner-section-area sp2 pb-[120px] max-md:pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* contact details starts */}
              <div className="grid grid-cols-3 gap-4 justify-between max-md:flex max-md:flex-col">
                <div className="w-full col-span-3 flex relative overflow-hidden bg-[#f3f5f4] px-[30px] py-[12px] rounded">
                  <div className="flex items-center gap-[10px]">
                    <div className="flex justify-center relative z-10">
                      <span className="inline-flex justify-center items-center p-[10px] rounded-full bg-[#243A5E]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={20}
                          height={20}
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                            stroke="#ffffff"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                            stroke="#ffffff"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <p className="text-base leading-[27px] text-primary-100 mb-0">
                        F-202, 2nd Floor, Eastern business district, Neptune, Lbs marg, Bhandup (west), Mumbai-400078
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full col-span-1 relative flex items-center overflow-hidden bg-[#f3f5f4] px-[30px] py-[12px] rounded">
                  <div className="flex items-center gap-[10px]">
                    <div className="flex justify-center relative z-10">
                      <span className="inline-flex justify-center items-center p-[10px] rounded-full bg-[#243A5E]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={20}
                          height={20}
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M4 18L9 12M20 18L15 12M3 8L10.225 12.8166C10.8665 13.2443 11.1872 13.4582 11.5339 13.5412C11.8403 13.6147 12.1597 13.6147 12.4661 13.5412C12.8128 13.4582 13.1335 13.2443 13.775 12.8166L21 8M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z"
                            stroke="#ffffff"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <p className="text-base leading-[27px] text-primary-100 mb-0">
                        support@kavatchhealthcare.com
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full col-span-1 relative flex items-center overflow-hidden bg-[#f3f5f4] px-[30px] py-[12px] rounded">
                  <div className="flex items-center gap-[10px]">
                    <div className="flex justify-center relative z-10">
                      <span className="inline-flex justify-center items-center p-[10px] rounded-full bg-[#243A5E]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={20}
                          height={20}
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M14.05 6C15.0268 6.19057 15.9244 6.66826 16.6281 7.37194C17.3318 8.07561 17.8095 8.97326 18 9.95M14.05 2C16.0793 2.22544 17.9716 3.13417 19.4163 4.57701C20.8609 6.01984 21.7721 7.91101 22 9.94M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z"
                            stroke="#ffffff"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <p className="text-base leading-[27px] text-primary-100 mb-0">
                        18002681155
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full col-span-1 relative flex items-center overflow-hidden bg-[#f3f5f4] px-[30px] py-[12px] rounded">
                  <div className="flex items-center gap-[10px]">
                    <div className="flex justify-center relative z-10">
                      <span className="inline-flex justify-center items-center p-[10px] rounded-full bg-[#243A5E]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8V12L15 15" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                      <circle cx="12" cy="12" r="9" stroke="#FFFFFF" stroke-width="2" />
                    </svg>
                      </span>
                    </div>
                    <div>
                      <p className="text-base leading-[27px] text-primary-100 mb-0">
                        Monday - Friday (09:30AM - 06:30PM)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* contact details ends */}
            </div>
          </div>
          <div className="row mt-[20px]">
            <div className="col-lg-6">
              <div className="works-images-area">
                <div className="img1 flex justify-center image-anime">
                  <img src="assets/img/all-images/footer/footer-img.png" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="contact-boxarea">
                <h4>Connect With Us</h4>
                <div className="space20" />
                <p>
                  Your trusted partner is just a message away.
                  <br className="d-lg-block d-none" /> Reach out to us — we’re always happy to help.
                </p>
                <div className="space6" />
                <form onSubmit={onSendEmail} className="row">
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input type="text" placeholder="Full Name*" value={notification?.name}
                        required onChange={(e) => setNotification({ ...notification, name: e.target.value })} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input type="tel" placeholder="Phone Number*" value={notification?.phone}
                        required onChange={(e) => setNotification({ ...notification, phone: e.target.value })} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input type="email" placeholder="Email Address*" value={notification?.email}
                        required onChange={(e) => setNotification({ ...notification, email: e.target.value })} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-area">
                      <input type="text" placeholder="Subject*" value={notification?.subject}
                        required onChange={(e) => setNotification({ ...notification, subject: e.target.value })} />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-area">
                      <textarea className="resize-none" placeholder="Your Message" value={notification?.message || ""}
                        required onChange={(e) => setNotification({ ...notification, message: e.target.value })} />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="space10" />
                    <div className="input-area">
                      <button type="submit" className="vl-btn6 flex items-center gap-[8px] justify-center">
                        <span>Submit Now</span>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={22}
                            height={22}
                            viewBox="0 0 22 22"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/*===== CONTACT AREA ENDS =======*/}
    </>
  );
};

export default Contact;
